import { LoaderContextual } from './loader-contextual';
import { LoaderGlobal } from './loader-global';
export const LoadingIndicator = () => null;
LoadingIndicator.Global = LoaderGlobal;
LoadingIndicator.Contextual = LoaderContextual;
//# sourceMappingURL=loading-indicator.js.map